import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";
import AllPatients from "./AllPatients";
import NewRequestspatients from "./NewRequestspatients";
import ReviewPatient from "./ReviewPatient";
import ReviewPopup from "./ReviewPopup";
import AddPatientpopup from "./AddPatientpopup";

const Patients = () => {
  const [activeTab, setActiveTab] = useState("allPatients");
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  const [showPopup, setShowPopup] = useState(false);
  const [addpatientpopup, setaddpatientpopup] = useState(false);

  const handlepatientOpenPopup = () => {
    setaddpatientpopup(true);
  };

  const handlepatientClosePopup = () => {

    setaddpatientpopup(false);
  };


  const handleClosePopup = () => {
    setShowPopup(false);
  };


  const navigate = useNavigate()
  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="dashboard-content">
        <Navbar 
        onClick= {()=>{navigate("/profile")}}
        />
        <div
          className="dashboard-cards"
          style={{ paddingLeft: 30, paddingRight: 30 }}
        >
          <div className="clinic-providers-container">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div className="headerheader">
                <div className="CLINIC-PROVIDERS-txt">
                  PROVIDER PATIENT ROASTER{" "}
                </div>
                <p className="clicnic-provider-paragraf">
                  Customize Mind Well Connect according to your Clinic needs
                </p>
              </div>
              <button
                className="add-provider-button"
                onClick={handlepatientOpenPopup}
              >
                Add Patient
              </button>
            </div>

            <div className="buttons">
              <button
                className={`tab-buttontwoo ${
                  activeTab === "allPatients" ? "active" : ""
                }`}
                onClick={() => handleTabClick("allPatients")}
              >
                All Patients
              </button>
              <button
                className={`tab-buttontwoo ${
                  activeTab === "newRequests" ? "active" : ""
                }`}
                onClick={() => handleTabClick("newRequests")}
              >
                New Requests
              </button>
              {/* <button className={`tab-buttontwoo`} onClick={handleOpenPopup}>
                Review
              </button> */}
            </div>
            {activeTab === "allPatients" && <AllPatients  addpatientpopup={addpatientpopup} />}
            {activeTab === "newRequests" && <NewRequestspatients />}
          </div>
        </div>
      </div>
      {/* <ReviewPopup/> */}
      {showPopup && <ReviewPopup onClose={handleClosePopup} />}
      {addpatientpopup && <AddPatientpopup onClose={handlepatientClosePopup} />}
    </div>
  );
};

export default Patients;
